<template>
 <div style="margin: 10px auto; max-width: 300px; padding: 0 10px;">

    <div style="text-align: center;"><img src="@/assets/images/banner-1.svg" alt="" /></div>

    <h1 style="text-align: center; margin: 30px 0;">England Premier League</h1>

    <div style="text-align: center;" v-if="ticket">{{$t('game')}} № <strong>{{ticket[0].GameID}}</strong></div>

    <div style="text-align: center;"><strong>{{date}}</strong></div>

    <div style="margin-top: 20px; border-top: 1px solid #333;" v-for="item in ticket"><!-- repeat block -->
      <div style="margin-bottom: 5px;" >{{getteams(item.HomeTeam)}} VS {{getteams(item.AwayTeam)}}</div>
      <div style="margin-bottom: 5px; font-weight: bold;" >{{$t('betplaced')}}: {{betName(item.Bet)}}</div>
      <template>
        <div>{{$t('odds')}}: {{item.Price}}</div>
        <div style="font-weight: bold;" v-if="!type">{{$t('sum')}}: {{item.Amount}}</div>
      </template>
      <div v-if="!type">{{$t('pwin')}}: {{(item.Price * item.Amount).toFixed(2)}}</div>
      <div style="font-weight: bold;"></div>
    </div>
    <div style="border-top: 1px solid #333;"></div>
    <div style="font-weight: bold;" v-if="type">{{$t('sum')}}: {{ticket.map(item => item.Amount).reduce((a, b) => parseFloat(a) + parseFloat(b))}}</div>
    <div v-if="type">{{$t('odds')}}: {{ticket.map(item => item.Price).reduce((a, b) => parseFloat(a) * parseFloat(b)).toFixed(2)}}</div>
    <div >{{$t('twin')}}: {{getTotal()}}</div>
    <barcode style="border-top: 1px solid #333;" :value="Code"></barcode>
    

  </div>
</template>

<script>
  import i18n from '@/i18n'
  import VueBarcode from '@chenfengyuan/vue-barcode';

  export default{
    i18n,
    props: ['ticket', 'teams', 'Code', 'date', 'type'], // , 'name'
    name: 'Payment',
    data: ()=>{
      return {
        cardnum: '',
      }
    },
    components: {
      barcode: VueBarcode
    },
    computed: {

    },
    methods: {
      betName(name){
        if(name == "GG") return this.$t('gg')
        if(name == "NG") return this.$t('ng')
        if(name.includes('Over')){
          if(name.includes('Home')) return this.$t('home')+this.$t('over')+name.slice(8)
          if(name.includes('Away')) return this.$t('away')+this.$t('over')+name.slice(8)
          if(name[0] == "1" || name[0] == "X" || name[0] == "2") return name[0]+this.$t('over')+name.slice(5)
          return this.$t('over')+name.slice(4)
        } 
        if(name.includes('Under')){
          if(name.includes('Home')) return this.$t('home')+this.$t('under')+name.slice(9)
          if(name.includes('Away')) return this.$t('away')+this.$t('under')+name.slice(9)
          if(name[0] == "1" || name[0] == "X" || name[0] == "2") return name[0]+this.$t('under')+name.slice(6)
          return this.$t('under')+name.slice(5)
        }
        if(name.includes('Goals')) return this.$t('goals')+name.slice(5)
        return name
      },
      PayCard(){
        this.$parent.$emit('modalClosed');
      },
      getteams(team){
        let result = this.teams.filter(item => item.id == team);
        return result[0].Abriviation
      },
      getTotal(){
        let total = 0; 
        if(!this.type){
          for(let i = 0; i < this.ticket.length; i++){
            total += this.ticket[i].Price * this.ticket[i].Amount;
          }
          return total.toFixed(2)
        }else{
          let coeff = this.ticket.map(item => item.Price).reduce((a, b) => parseFloat(a) * parseFloat(b));
          let sum = this.ticket.map(item => item.Amount).reduce((a, b) => parseFloat(a) + parseFloat(b));
          total = coeff.toFixed(2) * sum;
          return total.toFixed(2);
        }
      }
    }
  };
</script>

<style scopped>
    *, *:before, *:after {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    vertical-align: baseline;
  }
  *:focus, a:focus {
    outline: 0;
    outline-offset: 0;
  }
  body{
    background-color: #fff;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
  }
</style>